<template>
	<div class="flex">
		<div class="md-layout flex_1 upload-group">
			<div class="md-layout-item">
				<md-card>
					<md-card-header class="md-card-header-icon text_center">
						<h3>
							{{ $t("seller.marketSounding.start.card.title") }}
						</h3>
					</md-card-header>
					<md-card-content>
						<div class="prospective-content">
							<h4 class="text_center font_bold margin_top">
								{{ $t("seller.marketSounding.start.card.subTitle") }}</h4>
							<div v-html="$t('seller.marketSounding.start.card.description')"/>

							<div class="flex flex_content_center  margin_top_40">
								<md-field class="margin_top w_33" style="min-width: 260px">
									<label class="font_base"
										   style="font-size: 12px">{{ $t("seller.marketSounding.start.card.documentAvailable") }}*</label>
									<TbSelect v-model="documentAvailable"
											  :search-allow="false"
											  :options="yesOrNoOptions"
											  options-value-field="value"
												options-display-field="displayValue"
									/>
								</md-field>
							</div>

							<div class="flex flex_content_center">
								<md-button v-if="!documentAvailable" class="md-primary margin_top_l"
										   @click="openProspectiveUpload(true)">
									{{ $t("seller.marketSounding.start.card.button") }}
								</md-button>
								<div v-else>
									<h4 class="text_center font_bold margin_top">
										{{ $t("seller.marketSounding.start.card.uploadHint") }}</h4>
									<FileUpload
										class="margin_top"
										v-on:changePercent="changePercent"
										:disable="isLoading"
										iconName="fa-file-text"
										accept="pdf"
										postType="SingleInvoice"
										:prospective="true"
										key="prospectiveFileUpload"
										ref="prospectiveFileUpload"
									></FileUpload>
								</div>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
		<ProspectiveExcelUpload class="flex_1" @uploaded="onUploaded"></ProspectiveExcelUpload>
	</div>
</template>
<script>

import FileUpload from "@/components/templates/FileUpload.vue";
import {mapGetters} from "vuex";
import ProspectiveExcelUpload from "@/components/templates/seller/prospective/ProspectiveExcelUpload.vue";

export default {
	components: {ProspectiveExcelUpload, FileUpload },
	data() {
		return {
			documentAvailable: false,
			yesOrNoOptions: [
				{ value: true, displayValue: this.$t("common.yes") },
				{ value: false, displayValue: this.$t("common.no") },
			],
			isLoading: false,
			videoUploadPercent: 0,
		};
	},
	methods: {
		onUploaded() {
			this.$emit("uploaded");
		},
		openProspectiveUpload(hideLeft = false) {
			let data = {};
			if (hideLeft) {
				this.$store.dispatch("setActionPdfList", []);
				this.$store.dispatch("setActionActivePdf", {});
			} else {
				data = this.pafList[0];
			}

			this.$store.dispatch("setActionPdfDialog", {
				show: true,
				prospective: true,
				hideLeft: hideLeft,
				onChange: this.onUploaded,
				data: data
			});
		},
		changePercent(data) {
			this.isLoading = true;
			this.videoUploadPercent = data.uploadPercent;
			if (data.uploadPercent >= 100) {
				setTimeout(() => {
					this.openProspectiveUpload();
					this.onUploaded();
					this.videoUploadPercent = 0;
					this.isLoading = false;
				}, 500);
			}
		},
	},
	computed: {
		...mapGetters({
			pafList: "pafList",
		})
	}
};
</script>

<style lang="scss" scoped>
	@import "../upload";

	.prospective-content {
		margin: 2rem 2rem 0;
	}
</style>